import withModule from './ModuleComponent';

export default class PureComponent<P = {}, S = {}> extends withModule(true)<P, S> {}
